import { createAxiosInstance } from './axios-instance.factory';
import { API_CONFIG } from './api.config';

export const apiClient = createAxiosInstance({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export const translationsClient = createAxiosInstance({
  baseURL: API_CONFIG.TRANSLATIONS_BASE_URL,
  timeout: API_CONFIG.TIMEOUT_MS,
  headers: {
    Accept: 'application/json',
  },
});

export const masterDataClient = createAxiosInstance({
  baseURL: API_CONFIG.MASTER_DATA_BASE_URL,
  timeout: API_CONFIG.TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});
